export function createUserGroup() {
  const random = Math.random()
  const scaled = random * 60 // 未加101时，范围是0到60（不包括60）
  const floored = Math.floor(scaled) + 101 // 加上101后，范围是101到160（包括160）
  return `${floored}`
}
